module.exports = __webpack_public_path__ + "img/C08TechAshokasWillRM_ua.6ed52703.webp";